export default __webpack_public_path__ + "static/char-s-15-chs-53f03ed1d4bd75429637b61714cad97d.png";